// Documentation pour l'application

// #region interractions

// #endregion

// #region dataLayer

/**
 * Options pour createFeature
 * @typedef {Object} CreateFeatureOption
 * @property {string|function} idFeature identifiant ou fonction renvoyant l'identifiant de la feature OL créée
 * @property {string|function} idLayer calque ou fonction renvoyant le calque de la feature OL créée
 * @property {string|function} geometryType type de géométrie ou fonction renvoyant le type de géométrie de la feature OL créée
 * @property {Array|function}  padding décalage du centre de la carte ou fonction renvoyant le décalage de la feature OL créée
 * @property {Object|function} properties properties ou fonction renvoyant les properties de la feature OL créée
 * @property {Object|function} digitalizeOptions options de digitalisation ou fonction renvoyant les options de la feature OL créée (voir doc digit)
 * @property {Object|function} createTemplates liste de features (type geojson positionnées en [0,0]) a utiliser comme template de création de multigéométrie
 */

// #endregion

// #region Barre d'outil de création

/**
 * @typedef {('select'| 'rectangular'| 'multiselect'| 'zonal'| 'polygon' | 'create' | 'separator')} toolType
 */

/** Outil de la barre d'outil
 * @typedef {Object} SelectCreateTool
 * @property {string} toolId Id de l'outil (renvoyé lors d'un event "createfeature:create" ou "change:selection")
 * @property {toolType} type type d'outil 'select', 'rectangular', 'multiselect', 'zonal', 'polygon' , 'create' , 'separator'
 * @property {string} title tooltip
 * @property {Element|string} html contenu du bouton
 * @property {string} [icon] icone si html non saisie (utilisé comme <i class='icon'/>)
 * @property {boolean} [selectOnce] Désactive un outil de sélection lorsqu'une sélection est effectuée
 * @property {ControlBar[]} [hideControlBarOnCreate] Liste de controlbar a masquer lors de l'utilisation de l'outil de creation
 * @property {CreateFeatureOption} options Option pour l'outil (de creation uniquement)
 *
*/

/**
 * Options de barre d'outil de selection / creation
 * @typedef {Object} SelectCreateOptions
 * @property {Object} viewer Instance de kmapviewer
 * @property {string} className classe de la barre de selection
 * @property {SelectCreateTool[]} tools liste ds outils
 */

// #endregion

/**
 * Une légende
 * @typedef {Object} LegendOption
 * @typedef {String} label Titre
 * @typedef {String} sublabel sous-titre
 * @typedef {Number} order ordre d'affichage, les plus élevé en haut
 * @typedef {String} property propriétés des features à utiliser
 * @typedef {{String:String}?} discoverValues valeurs a découvrir dans la propriété avec leurs libellés @example {BRT:'Branchement'}
 * @typedef {{label:String}?} discoverValuesFallback valeur par défaut pour les valeurs non découverte
 * @typedef {Object[]?} values valeurs pour une légende fixe (prend l'ascendant sur le mode automatique ou discors)
 * @typedef {String} values.value valeur test
 * @typedef {String} values.label libellé à afficher
 * @typedef {String} values.geometryType type de géométrie associée a la valeur
 */

/** Options pour la légende
 * @typedef {LegendOption[]} LegendOptions
*/

/** Option pour la strategy de chargement des données
 * @typedef {Object} loadingStrategy
 * @typedef {boolean?} bboxStrategy utiliser la strategy bbox, defaut false
 * @typedef {Object?} tileStrategy Options pour la stratégie de tuile
 * @typedef {Object?} tileStrategy.tileSize taille des tuiles en pixel, default 256
*/
